import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { currencyCode } from "@/lib/money";

const LOCALE = { it: "it-IT", en: "en-US", es: "es-ES", fr: "fr-FR", de: "de-DE" };
export const localeFor = (lng) => LOCALE[lng] || "it-IT";

export function formatCurrency(v, lng, currency = "EUR") {
  return new Intl.NumberFormat(localeFor(lng), { style: "currency", currency: currencyCode(currency) }).format(Number(v || 0));
}
export function formatDate(d, lng) {
  if (!d) return "";
  return new Intl.DateTimeFormat(localeFor(lng), { day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(d));
}
export function formatDateTime(d, lng) {
  if (!d) return "";
  return new Intl.DateTimeFormat(localeFor(lng), { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(d));
}
export function formatTime(d, lng) {
  if (!d) return "";
  return new Intl.DateTimeFormat(localeFor(lng), { hour: "2-digit", minute: "2-digit" }).format(new Date(d));
}
export function formatWeekday(d, lng) {
  return new Intl.DateTimeFormat(localeFor(lng), { weekday: "short" }).format(new Date(d));
}

// Locale-aware helpers bound to the current UI language.
export function useFormat(currencyOverride) {
  const { studio } = useAuth();
  const currency = currencyCode(currencyOverride || studio);
  const { i18n } = useTranslation();
  const lng = i18n.language;
  return {
    c: (v, recordCurrency) => formatCurrency(v, lng, currencyCode(recordCurrency, currency)),
    currency,
    d: (x) => formatDate(x, lng),
    dt: (x) => formatDateTime(x, lng),
    t: (x) => formatTime(x, lng),
    wd: (x) => formatWeekday(x, lng),
    lng,
  };
}
